import React from 'react'
import { FieldSet } from 'components/formElements'
import styles from './NestedFieldSet.module.scss'

const NestedFieldSet = (props) => (
    <FieldSet {...props} className={styles.nestedFieldset} />
)

export { NestedFieldSet }
